<template>
    <div class="hidden lg:block">
        <full-width-container class="bg-r-gray-ultralight">
            <content-container :default-padding="false" class="px-3 lg:px-12">
                <title-bar :back-route="{ name: backRouteName }">
                    {{ property.name }}
                </title-bar>
            </content-container>
        </full-width-container>
    </div>
</template>
<script>
import ContentContainer from "@guest/common/ContentContainer";
import FullWidthContainer from "@guest/common/FullWidthContainer.vue";
import TitleBar from "@guest/common/TitleBar";

export default {
    components: {
        ContentContainer,
        TitleBar,
        FullWidthContainer,
    },
    props: {
        property: {
            required: true,
            type: Object,
        },
        backRouteName: {
            required: false,
            default: null,
            type: Object | null,
        },
    },
};
</script>
